export const smsSegmentCalculator = (message: string) => {
  if (message.length <= 160) {
    return 1
  }

  return Math.round(message.length / 153)
}
